import { Text } from '@24i/nxg-sdk-quarks';

const ScrollableText = Text;
export default ScrollableText;
